export default __webpack_public_path__ + "assets/models/dd50dcd534ffc4c9b6d9e8a0c3443958.glb";